import { Button, Modal } from "antd";
import { useEffect } from "react";
import { FaDownload } from "react-icons/fa";
import { IoCloseCircleOutline } from "react-icons/io5";
import AntdBreadcrumbs from "../../../components/Common/Breadcrumbs/AntdBreadcrumbs";

export const ConcernDetailsModal = ({ isVisible, onClose, modalData }) => {
  useEffect(() => {
    if (isVisible) {
      const modalContent = document.querySelector(
        ".ant-modal .ant-modal-content"
      );
      const modalBody = document.querySelector(".ant-modal .ant-modal-body");

      if (modalContent) {
        modalContent.style.borderRadius = "10px";
        modalContent.style.padding = "20px";
      }

      if (modalBody) {
        modalBody.style.maxHeight = "400px";
        modalBody.style.overflowY = "auto";
      }
    }
  }, [isVisible]);

  return (
    <Modal
      title={
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <span>
            {modalData?.name.charAt(0).toUpperCase() + modalData?.name.slice(1)}
          </span>
          <span style={{ cursor: "pointer" }} onClick={onClose}>
            X
          </span>
        </div>
      }
      visible={isVisible}
      onCancel={onClose}
      footer={null}
      width={600}
      centered
    >
      {modalData && (
        <div>
          <div>
            <strong>Email: </strong>
            {modalData.email}
          </div>
          <div style={{ marginTop: 16, backgroundColor: "#f7f7f7" }}>
            <p>{modalData.tell_us_more}</p>
          </div>
        </div>
      )}
    </Modal>
  );
};

export const FileModal = ({
  visible,
  onCancel,
  attachment,
  title = "Attachment",
  onDownload,
}) => {
  // Handle the file download
  const handleDownload = () => {
    const fileUrl = `${process.env.REACT_APP_API_URL}healthsy-pharmacy/careers/uploads/careers/${attachment}`;
    const link = document.createElement("a");
    link.href = fileUrl;
    link.download = attachment;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  useEffect(() => {
    if (visible) {
      const modalContent = document.querySelector(
        ".ant-modal .ant-modal-content"
      );
      const modalBody = document.querySelector(".ant-modal .ant-modal-body");

      if (modalContent) {
        modalContent.style.height = "70vh";
      }

      if (modalBody) {
        modalContent.style.height = "75vh";
      }
    }
  }, [visible]);

  return (
    <Modal
      title={title}
      visible={visible}
      onCancel={onCancel}
      footer={[
        <Button key="download" type="primary" onClick={handleDownload}>
          <FaDownload /> Download
        </Button>,
        <Button key="close" onClick={onCancel}>
          Close
        </Button>,
      ]}
      closeIcon={<IoCloseCircleOutline size={24} />}
      centered
      style={{ top: 20 }}
      width={600}
      bodyStyle={{ height: "60vh" }}
      destroyOnClose
    >
      <div style={{ height: "60vh" }}>
        <iframe
          src={`${process.env.REACT_APP_API_URL}healthsy-pharmacy/careers/uploads/careers/${attachment}`}
          width="100%"
          height="100%"
          title="Attachment Viewer"
        />
      </div>
    </Modal>
  );
};

export const StoreLocationBreadcrumbsList = ({ page, edit = false }) => {
  const breadcrumbsList = [
    {
      text: "Dashboard ",
      link: "/",
    },
    {
      text: "Franchise Programme ",
      link: "/franchise-programme",
    },
    {
      text: "Store Locations",
      link: "/franchise-customers/store-locations",
    },
    { text: `${!edit ? "Add" : "Edit"} Store Locations /`, link: "" },
  ];

  return (
    <>
      <AntdBreadcrumbs
        className="healthsyMasterBreadCrumbs pb-0"
        breadcrumbsList={breadcrumbsList}
      />
    </>
  );
};
